import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { PlainHeaderAreaComponent } from './plain-header-area/plain-header-area.component';
import { ButtonModule } from '../../components/buttons';

@NgModule({
  declarations: [PlainHeaderAreaComponent],
  exports: [PlainHeaderAreaComponent],
  providers: [],
  imports: [CommonModule, UiTranslateModule, ButtonModule],
})
export class HeadersModule {}
